// import React, { useEffect } from 'react';
// import Swiper from 'swiper';
// import 'swiper/css';
// import 'swiper/css/autoplay';
// import { Autoplay } from 'swiper/modules';

// const MarquSection = () => {
//   useEffect(() => {
//     new Swiper('.swiper--top', {
//       modules: [Autoplay],
//       spaceBetween: 0,
//       centeredSlides: true,
//       speed: 9000,
//       autoplay: {
//         delay: 1,
//         disableOnInteraction: false,
//       },
//       loop: true,
//       slidesPerView: 'auto',
//       allowTouchMove: false,
//     });
//   }, []);

//   const slides = [
//     " Quality Homes And Builders — Trusted Residential Construction",
//     "Building Modern Homes with Quality & Care",
//     "Crafting Durable Homes for Everyday Living",
//     "Your Vision, Our Commitment to Quality Homes",
//   ];

//   return (
//     <section className="wpo-marqu-section swiper--top">
//       <h2 className="d-none">Marquee</h2>
//       <div className="swiper-wrapper">
//         {[...slides, ...slides, ...slides].map((text, index) => (
//           <div key={index} className="swiper-slide" style={{fontWeight:"900"}}>{text}</div>
//         ))}
//       </div>
//     </section>
//   );
// };

// export default MarquSection;


import React, { useEffect } from 'react';
import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';

const MarquSection = () => {
  useEffect(() => {
    new Swiper('.swiper--top', {
      modules: [Autoplay],
      spaceBetween: 0,
      centeredSlides: true,
      speed: 9000,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      loop: true,
      slidesPerView: 'auto',
      allowTouchMove: false,
    });
  }, []);

  const slides = [
    "Quality Homes And Builders — Trusted Residential Construction",
    "Building Modern Homes with Quality & Care",
    "Crafting Durable Homes for Everyday Living",
    "Your Vision, Our Commitment to Quality Homes",
  ];

  return (
    <section
      className="wpo-marqu-section swiper--top"
      style={{
        overflow: "hidden",
      }}
    >
      <h2 className="d-none">Marquee</h2>

      <div className="swiper-wrapper">
        {[...slides, ...slides, ...slides].map((text, index) => (
          <div
            key={index}
            className="swiper-slide"
            style={{
              fontWeight: 900,
              whiteSpace: "nowrap",

              /* ✅ Mobile = 40px minimum */
              fontSize: "clamp(40px, 6vw, 72px)",

              /* spacing between repeats */
              paddingRight: "3rem",

              lineHeight: "1.1",
            }}
          >
            {text}
          </div>
        ))}
      </div>
    </section>
  );
};

export default MarquSection;
